var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9025400_file_csv_icon",
    "data-name": "9025400_file_csv_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20767",
    "data-name": "Rectangle 20767",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49056",
    "data-name": "Path 49056",
    d: "M172,168l1.563,3.75,1.563-3.75",
    transform: "translate(-158.563 -154.875)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49057",
    "data-name": "Path 49057",
    d: "M46.813,171.32a1.641,1.641,0,0,1-1.094.43,1.882,1.882,0,0,1,0-3.75,1.641,1.641,0,0,1,1.094.43",
    transform: "translate(-40.563 -154.875)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49058",
    "data-name": "Path 49058",
    d: "M112,170.516a1.969,1.969,0,0,0,1.172.391c.7,0,1.328-.234,1.328-1.016,0-1.25-2.5-.7-2.5-1.875A1.032,1.032,0,0,1,113.172,167a1.969,1.969,0,0,1,1.172.391",
    transform: "translate(-103.25 -153.953)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49059",
    "data-name": "Path 49059",
    d: "M48,39.5V32.625A.625.625,0,0,1,48.625,32h7.5L60.5,36.375V39.5",
    transform: "translate(-44.25 -29.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49060",
    "data-name": "Path 49060",
    d: "M152,32v4.375h4.375",
    transform: "translate(-140.125 -29.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.366804bec0568d3cde0ed3fb46712987.svg";
export { ForwardRef as ReactComponent };